import React from "react";
import { Card, Col, Row, Statistic } from "antd";
import { Locale } from "../../../utils";
import { formatPercent, fenToYuan } from "../../../utils/statistics/statisticsUtils";

const i18n = Locale.getInstance();

function CompareItem({ label, item, isMoney }) {
  if (!item) {
    return null;
  }
  const percent = item.percent;
  const color = percent > 0 ? "#3f8600" : percent < 0 ? "#cf1322" : undefined;

  return (
    <Col xs={24} sm={12} md={8}>
      <Card bordered={false} size="small" className="statistics-page__compare-card">
        <Statistic
          title={label}
          value={isMoney ? fenToYuan(item.current) : item.current}
          prefix={isMoney ? "¥" : undefined}
          suffix={
            <span style={{ fontSize: 14, color, marginLeft: 8 }}>
              {formatPercent(percent)}
            </span>
          }
        />
        <div className="statistics-page__compare-prev">
          {i18n.t("statisticsCommon.previousPeriod")}: {isMoney ? fenToYuan(item.previous) : item.previous}
        </div>
      </Card>
    </Col>
  );
}

export default function PeriodCompare({ items = [] }) {
  if (!items.length) {
    return null;
  }

  return (
    <Card title={i18n.t("statisticsCommon.periodCompare")} className="statistics-page__section">
      <Row gutter={[16, 16]}>
        {items.map((item) => (
          <CompareItem
            key={item.key}
            label={item.label}
            item={item.data}
            isMoney={item.isMoney}
          />
        ))}
      </Row>
    </Card>
  );
}
